export default __webpack_public_path__ + "maps-examples-heatmap-example-thumbnail-960-9a20d9dca5c9c749b5c0876fc1b9b468.webp";